import { render, staticRenderFns } from "./Trainings.vue?vue&type=template&id=322a6ad2&scoped=true&lang=pug&"
import script from "./Trainings.vue?vue&type=script&lang=js&"
export * from "./Trainings.vue?vue&type=script&lang=js&"
import style0 from "./Trainings.vue?vue&type=style&index=0&id=322a6ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a6ad2",
  null
  
)

export default component.exports